import { jsxs as i, jsx as u } from "react/jsx-runtime";
import { useState as C, useCallback as M } from "react";
import b from "./SubMenu/SubMenu.js";
import m from "./TopLevelNav/TopLevelNav.js";
import { Wrapper as v } from "./styled.js";
const j = ({ items: o, headerHeight: l, appElement: a }) => {
  var r, p;
  const [n, e] = C([]), c = () => e([]), d = M(
    (s) => {
      const { id: t } = s;
      n.length === 0 || t !== o[n[0]].id ? e([o.findIndex((f) => f.id === t)]) : e([]);
    },
    [o, n]
  );
  return /* @__PURE__ */ i(v, { children: [
    /* @__PURE__ */ u(
      m,
      {
        activeId: ((r = o[n[0]]) == null ? void 0 : r.id) ?? "",
        items: o,
        onClick: d
      }
    ),
    /* @__PURE__ */ u(
      b,
      {
        openMenu: n,
        setOpenMenu: e,
        items: ((p = o == null ? void 0 : o[n[0]]) == null ? void 0 : p.subItems) || [],
        onClose: c,
        headerHeight: l,
        appElement: a
      }
    )
  ] });
};
export {
  j as default
};
